import styled from 'react-emotion';
import { styles } from './styles';

interface Props {
  type?: string;
  large?: boolean;
}

export const InputLabel = styled<'label'>('label')<Props>(({ type, large }) => {
  return styles.label(type, large);
});

export const LinkLabel = InputLabel.withComponent('a');
